import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { EMPTY, Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "../service/auth/auth.service";
import { translate } from '@jsverse/transloco';

@Injectable()
export class SessionInvalidationInterceptorService implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 &&
            (error.error?.error_code === 'SESSION_INVALIDATED' || error.error?.error_code === 'SESSION_EXPIRED')
        ) {
          // Signal global error handlers to avoid red snackbars during forced logout.
          sessionStorage.setItem('logout_in_progress', '1');

          const message = error.error.error_code === 'SESSION_EXPIRED'
            ? translate('settings.auth.session_expired')
            : translate('settings.auth.session_invalidated');

          this.authService.logout(JSON.stringify({
            showSessionSnackbar: true,
            message: message
          }));

          // Consume handled session errors to prevent generic red error snackbars.
          return EMPTY;
        }

        return throwError(() => error);
      }),
    );
  }
}